import React, { useState } from "react";
import playerData from "../assets/playersdata.json";
import pdfFile from "../assets/Chandigarh_Id.pdf";
import IdForm from "../assets/State_Player_ID_Form.pdf";
import './Cbaid.css';

const handleDownload = () => {
  const link = document.createElement("a");
  link.href = pdfFile;
  link.download = "Chandigarh_Id.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleDownloadIdForm = () => {
  const link = document.createElement("a");
  link.href = IdForm;
  link.download = "State_Player_ID_Form.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function CBA_ID() {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPlayers, setFilteredPlayers] = useState(playerData);
  const [sortConfig, setSortConfig] = useState({
    key: "Name",
    direction: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    const filtered = playerData.filter(
      (player) => player["Name"] && player["Name"].toLowerCase().includes(value)
    );
    setFilteredPlayers(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredPlayers].sort((a, b) => {
      const valA = a[key] ? a[key].toString() : "";
      const valB = b[key] ? b[key].toString() : "";
      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setFilteredPlayers(sortedData);
  };

  const highlightText = (text, query) => {
    if (!text) return "";
    if (!query) return text;
    const textStr = text.toString();
    const parts = textStr.split(new RegExp(`(${query})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span key={index} className="highlight-text">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const renderSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return (
        <span className="sort-indicator">
          {sortConfig.direction === "asc" ? "▲" : "▼"}
        </span>
      );
    }
    return <span className="sort-indicator" style={{ opacity: 0.3 }}>⇅</span>;
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredPlayers.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredPlayers.length / rowsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div className="cbaid-container container py-5">
      <h2 className="text-center mb-3 cbaid-title text-gradient text-uppercase">CBA ID Player Directory</h2>
      <p className="lead text-center text-muted mb-5">
        Find registration details and check official player IDs in the state database.
      </p>

      {/* Unified Action Buttons */}
      <div className="cbaid-action-bar">
        <button className="btn btn-yonex-green" onClick={handleDownloadIdForm}>
          <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
          </svg>
          Download Player ID Form
        </button>
        <button className="btn btn-yonex-blue" onClick={handleDownload}>
          <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
            <path d="M4.5 12.5A.5.5 0 0 1 5 12h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 10h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm0-2A.5.5 0 0 1 5 8h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5z"/>
          </svg>
          Download Full Player List (PDF)
        </button>
      </div>

      {/* Styled Search Bar */}
      <div className="search-wrapper">
        <div className="search-input-group">
          <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16" className="search-icon-svg">
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
          </svg>
          <input
            type="text"
            className="search-input"
            placeholder="Search players by name..."
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </div>

      {/* Player List Table */}
      <div className="cba-table-card">
        <div className="table-responsive">
          <table className="table table-hover table-striped cba-table">
            <thead>
              <tr>
                <th onClick={() => handleSort("CHDID Number")}>CHDID No. {renderSortIndicator("CHDID Number")}</th>
                <th onClick={() => handleSort("Name")}>Name {renderSortIndicator("Name")}</th>
                <th onClick={() => handleSort("Father's Name")}>Father's Name {renderSortIndicator("Father's Name")}</th>
                <th onClick={() => handleSort("Date of Birth")}>DOB {renderSortIndicator("Date of Birth")}</th>
                <th onClick={() => handleSort("Adress ")}>Address {renderSortIndicator("Adress ")}</th>
                <th onClick={() => handleSort("Phone Number")}>Phone Number {renderSortIndicator("Phone Number")}</th>
                <th onClick={() => handleSort("Gender")}>Gender {renderSortIndicator("Gender")}</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.length > 0 ? (
                currentRows.map((player, index) => (
                  <tr key={index}>
                    <td className="fw-bold text-dark">{player["CHDID Number"]}</td>
                    <td>{highlightText(player["Name"], searchTerm)}</td>
                    <td>{highlightText(player["Father's Name"], searchTerm)}</td>
                    <td>{player["Date of Birth"]}</td>
                    <td>{player["Adress "]}</td>
                    <td>{player["Phone Number"]}</td>
                    <td>
                      <span className={`badge ${player["Gender"] === "Male" ? "bg-primary-subtle text-primary" : "bg-danger-subtle text-danger"} px-2.5 py-1`}>
                        {player["Gender"]}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted py-5">
                    No results found for "{searchTerm}".
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="cba-pagination">
          <button
            className="btn btn-outline-secondary"
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            « First
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ‹ Prev
          </button>
          <span className="cba-pagination-info">
            Page <strong>{currentPage}</strong> of {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next ›
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            Last »
          </button>
        </div>
      )}
    </div>
  );
}

export default CBA_ID;
